import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Quote as SdkQuote} from '@sportngin/se-commerce-sdk';
import {map, Observable} from 'rxjs';
import {
  QuoteQuery,
  quoteQueryToQuoteParametersDto,
} from '../../../common/context-data';
import {Quote, sdkQuoteToQuote} from '../../model';
import {ApiModule} from '../api.module';
import {CommerceApiService} from './commerce-api.service';
import {Store} from '@ngrx/store';

interface VerticalInsureErrorResponse {
  message: string;
}

@Injectable({
  providedIn: ApiModule,
})
export class QuoteApiService extends CommerceApiService {
  readonly controllerPath: string = 'v3/commerce/shopper/quotes';

  constructor(
    protected http: HttpClient,
    protected store: Store,
  ) {
    super(http, store);
  }

  getQuote(query: QuoteQuery): Observable<Quote | undefined> {
    const quoteParameters = quoteQueryToQuoteParametersDto(query);
    const url = this.getUrl('/request');

    return this.POST<SdkQuote | VerticalInsureErrorResponse>(
      url,
      quoteParameters,
      this.getOptions({withCredentials: true}),
    ).pipe(
      map(resp => {
        const {message} = resp as VerticalInsureErrorResponse;
        if (message && message.toLowerCase().includes('error')) {
          throw new Error(message);
        } else {
          const sdkQuote = <SdkQuote>resp;
          return sdkQuoteToQuote(sdkQuote);
        }
      }),
    );
  }

  getUrl(path = ''): string {
    path = `${this.controllerPath}${path}`;
    return super.getUrl(path);
  }
}
